import { textAreaStyles as fastTextAreaStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationTextAreaStyles = (context, definition) => css `
  ${fastTextAreaStyles(context, definition)}
  :host .control {
    padding: calc(var(--design-unit) * 3px);
  }
`;
